module.exports = __webpack_public_path__ + "static/about.8bf9bbab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/about.jpg
// module id = 175
// module chunks = 144251824217401 183328146348521